import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { push } from 'connected-react-router';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { isMobile } from '@widergy/web-utils/lib/browser';
import { UTLabel } from '@widergy/energy-ui';

import BillActions from 'redux/bill/actions';
import { billPropTypes } from 'types/billTypes';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import { ROUTES } from 'constants/routes';
import { MobileBreakpoint } from 'constants/deviceSizes';

import { billForView } from '../../utils';

import BillDetail from './layout';

class BillDetailsContainer extends Component {
  componentDidMount() {
    window.addEventListener('resize', this.handleRedirection);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleRedirection);
  }

  handleRedirection = () =>
    (!this.props.bill || !isMobile(MobileBreakpoint)) && this.props.dispatch(push(ROUTES.BILLS));

  amountRenderer = amount =>
    amount && (
      <UTLabel small semibold>
        {amount}
      </UTLabel>
    );

  formatBill = bill =>
    [
      {
        id: 1,
        title: `${message('Bills:amount')}:`,
        subtitle: this.amountRenderer(bill.download.amount),
        show: true
      },
      {
        id: 2,
        title: `${message('Bills:balance')}:`,
        subtitle: this.amountRenderer(bill.balance),
        show: appConfig.useBillsBalance
      },
      {
        id: 3,
        title: `${message('Bills:period')}:`,
        subtitle: bill.period,
        show: true
      },
      {
        id: 4,
        title: `${message('Bills:expiration')}:`,
        subtitle: bill.first_expiration_on,
        show: true
      },
      {
        id: 5,
        title: `${message('Commons:status')}:`,
        subtitle: bill.status,
        show: true
      },
      {
        id: 6,
        title: `${message('Bill:issued_on')}:`,
        subtitle: bill.issued_on,
        show: true
      },
      {
        id: 7,
        title: `${message('Bill:second_expiration_on')}:`,
        subtitle: bill.second_expiration_on,
        show: true
      },
      {
        id: 8,
        title: `${message('Bill:second_expiration_amount')}:`,
        subtitle: bill.second_expiration_amount,
        show: appConfig.useBillsSurchargeAmount
      },
      {
        id: 9,
        title: `${message('Bill:period')}:`,
        subtitle: `${moment(bill.period_started_on).format('L')} - ${moment(bill.period_ended_on).format(
          'L'
        )}`,
        show: true
      },
      {
        id: 10,
        title: message('Bills:documentType'),
        subtitle: bill.document_type,
        show: true
      },
      {
        id: 11,
        title: `${message('Bill:document_number')}:`,
        subtitle: bill.document_number,
        show: true
      }
    ].filter(field => field.show);

  render() {
    const { bill, onClickDownload } = this.props;

    return bill ? (
      <BillDetail formattedBill={this.formatBill(bill)} onClickDownload={onClickDownload} bill={bill} />
    ) : (
      <Redirect to={ROUTES.BILLS} />
    );
  }
}

const billSelector = createSelector(
  (store, props) => props.location.params,
  store => store.bill.bills,
  (id, bills) => id && bills.find(el => el.id === id)
);

const billFormattedSelector = createSelector(billSelector, billForView);

const mapStateToProps = (store, props) => ({
  bill: billFormattedSelector(store, props)
});

const mapDispatchToProps = dispatch => ({
  onClickDownload: billId =>
    dispatch(
      appConfig.bills.billDownloadOnPDF
        ? BillActions.getPrintedBillPDF(billId)
        : BillActions.getPrintedBill(billId, 'bills')
    ),
  dispatch
});

BillDetailsContainer.propTypes = {
  bill: billPropTypes,
  onClickDownload: func
};

export default connect(mapStateToProps, mapDispatchToProps)(BillDetailsContainer);
